import React from "react";

import { Product } from "../remote";
import FavoriteProduct from "./ProductDetails/FavoriteProduct";

interface Props {
  id: number;
}

export default function ProductGridItem({ id }: Props) {
  return (
    <Product id={id}>
      {({ data, error }) => {
        if (!data) {
          return (
            <progress className="progress is-small is-primary" max="100" style={{ borderRadius: 0 }}>
              15%
            </progress>
          );
        }

        return (
          <div className="card">
            <div className="card-content">
              <p className="title is-4">{data.name}</p>
              <p className="title is-6">{data.brand}</p>
              <FavoriteProduct id={id} />
            </div>
          </div>
        );
      }}
    </Product>
  );
}
